import React from 'react';
import { CTAButton } from './CTAButton';
export function EmotionalClose() {
  return <section id="oferta" className="w-full bg-gradient-to-b from-white to-pink-soft py-12 md:py-20 px-4" data-id="element-223">
      <div className="max-w-[680px] mx-auto text-center" data-id="element-224">
        <h2 className="font-heading font-bold text-2xl md:text-3xl text-dark-gray mb-8" data-id="element-225">
          Sí, quiero la guía + los 5 bonos GRATIS
        </h2>

        <div className="font-body text-dark-gray text-lg md:text-xl leading-relaxed space-y-4 mb-10" data-id="element-226">
          <p data-id="element-227">Podés seguir buscando tutoriales sueltos en YouTube.</p>
          <p data-id="element-228">O podés tener todo en un solo lugar:</p>
          <p className="font-bold text-pink-dark" data-id="element-229">
            La guía + los materiales + las medidas + la ruta + el acabado.
          </p>
          <p data-id="element-230">
            Todo por solo{' '}
            <span className="line-through text-medium-gray" data-id="element-231">$66,99</span> →{' '}
            <span className="text-pink-dark font-bold" data-id="element-232">$14</span> (80% OFF).
          </p>
          <p className="font-bold" data-id="element-233">La decisión es tuya.</p>
        </div>

        {/* CTA Final */}
        <CTAButton size="large" onClick={() => {
        if ((window as any).__ctaFired) return;
        (window as any).__ctaFired = true;
        if ((window as any).fbq) {
          ;
          (window as any).fbq('track', 'AddToCart', {
            content_name: 'Bikinis al Crochet Ebook',
            content_type: 'product',
            value: 14,
            currency: 'USD'
          });
          (window as any).fbq('track', 'InitiateCheckout', {
            content_name: 'Bikinis al Crochet Ebook',
            value: 14,
            currency: 'USD'
          });
        }
        setTimeout(() => {
          window.location.href = 'https://www.yennilemon.com/cart/44201631187079:1?country=US&locale=en-US';
        }, 300);
      }} data-id="element-234">
          Quiero mi guía + bonos ahora
        </CTAButton>

        <p className="text-center text-medium-gray font-body text-sm mt-4" data-id="element-235">
          Guía (<span className="line-through" data-id="element-236">$19,99</span>) + 5 bonos (
          <span className="line-through" data-id="element-237">$47</span> GRATIS) → Total{' '}
          <span className="line-through" data-id="element-238">$66,99</span> → Hoy $14
        </p>
      </div>
    </section>;
}